import React, { useState } from "react";
import { FaEye, FaSync, FaEyeSlash, FaTrash, FaEdit } from "react-icons/fa";

type Layer = {
  id: string;
  name: string;
  visibility: boolean;
};

const Layers: React.FC = () => {
  const [layers, setLayers] = useState<Layer[]>([
    { id: "1", name: "Layer 1", visibility: true },
    { id: "2", name: "Layer 2", visibility: false },
    // add more initial layers as needed
  ]);

  const handleToggleVisibility = (id: string) => {
    const newLayers = layers.map((layer) =>
      layer.id === id ? { ...layer, visibility: !layer.visibility } : layer
    );
    setLayers(newLayers);
  };

  const handleDelete = (id: string) => {
    const newLayers = layers.filter((layer) => layer.id !== id);
    setLayers(newLayers);
  };

  const handleEdit = (id: string) => {
    const newName = prompt("Enter new layer name:");
    if (newName !== null) {
      const newLayers = layers.map((layer) =>
        layer.id === id ? { ...layer, name: newName } : layer
      );
      setLayers(newLayers);
    }
  };

  const handleAddLayer = () => {
    const newName = prompt("Enter layer name:");
    if (newName !== null) {
      const newLayer = {
        id: (layers.length + 1).toString(),
        name: newName,
        visibility: true,
      };
      setLayers([...layers, newLayer]);
    }
  };

  return (
    <div className="p-4 w-full h-full">
      <div className="w-full h-full overflow-y-auto">
        <table className="min-w-full border-collapse block md:table">
          <tbody className="block md:table-row-group">
            {layers.map((layer) => (
              <tr key={layer.id} className="block md:table-row">
                <td className="block md:table-cell px-2 py-1 text-left border md:border-none">
                  {layer.name}
                </td>
                <td className="block md:table-cell px-2 py-1 text-right border md:border-none">
                  <button onClick={() => handleEdit(layer.id)} className="mx-1">
                    <FaSync />
                  </button>
                  <button
                    onClick={() => handleToggleVisibility(layer.id)}
                    className="mx-1"
                  >
                    {layer.visibility ? <FaEye /> : <FaEyeSlash />}
                  </button>
                  <button onClick={() => handleEdit(layer.id)} className="mx-1">
                    <FaEdit />
                  </button>
                  <button
                    onClick={() => handleDelete(layer.id)}
                    className="mx-1"
                  >
                    <FaTrash />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <button
          onClick={handleAddLayer}
          className="mt-4 px-4 py-2 border rounded"
        >
          Add Layer
        </button>
      </div>
    </div>
  );
};

export default Layers;
